import { CompleteAddress } from '../address/address.types';
import { UserENT } from '../user/user.types';

export interface Company extends CompleteAddress {
  id: number;
  name: string;
  description?: string;
  siret: string;
  tva: string | null;
  legalStatutes: keyof typeof CompanyLegalStatutes | null;
  KBIS_path: string | null;
  firstName_owner: string;
  lastName_owner: string;
  function_owner: string;
  email_owner: string;
  phone_owner: string;
  created_at: Date;
}

export type FullCompany = Company & UserENT & {
  id_user: number;
}

export interface PendingCompany extends Omit<Company, 'legalStatutes' | 'KBIS_path'> {
  id_company: number;
}

export enum CompanyLegalStatutes {
  EI = 'Entreprise individuelle',
  EURL = 'Entreprise unipersonnelle à responsabilité limitée',
  SARL = 'Société à responsabilité limitée',
  SA = 'Société anonyme',
  SAS = 'Société par actions simplifiée',
  SASU = 'Société par actions simplifiée unipersonnelle',
  SNC = 'Société en nom collectif',
  SCOP = 'Société coopérative de production',
  SCA = 'Société en commandite par actions',
  SCS = 'Société en commandite simple',
}
